import Vue from 'vue';

export default { 
    namespaced: true,
    state: {
        menuItems: null,
    }, 
    mutations: {
    }, 
    actions: {
        loadMenuItems({ commit, rootState }) {
            let routes = rootState.router.options.routes;

            // TODO parse routes to menuItems
        }
    }, 
    getters: {
    } 
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js